import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import useEvalRunConfigPersonaForm from "./useEvalRunConfigPersonaForm";
import EvalRunConfigPersonaForm from "./EvalRunConfigPersonaForm";

export default EvalRunConfigPersonaFormDialog;

function EvalRunConfigPersonaFormDialog(props) {
  const { persona, onClose, onConfirm, title, confirmCtaLabel } = props;
  // Replaced: the form now also returns attribute row errors and getPersona,
  // which turns the attribute rows back into the saved key -> value object.
  // const { formState, errors, validate, updateFormState } =
  //   useEvalRunConfigPersonaForm(persona);
  const {
    formState,
    errors,
    attributeErrors,
    validate,
    updateFormState,
    getPersona,
  } = useEvalRunConfigPersonaForm(persona);

  const handleConfirm = () => {
    if (!validate()) {
      return;
    }

    // Replaced: formState holds attributes as editable rows, not the saved shape.
    // onConfirm(formState);
    onConfirm(getPersona());
    onClose();
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogBody>
        <EvalRunConfigPersonaForm
          formState={formState}
          errors={errors}
          attributeErrors={attributeErrors}
          updateFormState={updateFormState}
        />
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button onClick={handleConfirm}>{confirmCtaLabel}</Button>
      </DialogActions>
    </Dialog>
  );
}
